import { render, staticRenderFns } from "./Form920.00.vue?vue&type=template&id=5fc0c056&scoped=true&"
import script from "./Form920.00.vue?vue&type=script&lang=js&"
export * from "./Form920.00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0c056",
  null
  
)

export default component.exports